import { all, call } from 'redux-saga/effects';

import authSaga from './auth';
import siteInfoSaga from './siteInfo';
import navigationSaga from './navigation';
import signupSaga from './signup';
import purchaseSaga from './purchase';
import regions from './regions';
import district from './district';
import schools from './schools';
import curriculum from './curriculum';
import profile from './profile';
import sendEmail from './sendEmail';
import resendPhoneVerification from './resendPhoneVerification';
import resetPassword from './resetPassword';
import resetEmail from './resetEmail';
import editAccount from './editAccount';
import purchaseHistory from './purchaseHistory';
import modifySubscription from './modifySubscription';
import cancelSubscription from './cancelSubscription';
import redeemReferralCode from './redeemReferralCode';
import resetUnauthedPassword from './resetUnauthedPassword';
import confirmEmail from './confirmEmail';
import plans from './plans';
import forgotPassword from './forgotPassword';
import updatePhone from './updatePhone';
import changeSchool from './changeSchool';
import marketingBanner from './marketingBanner';
import googleTagManager from './googleTagManager';
import deleteAccount from './deleteAccount';
import tutorAudit from './tutorAudit';
import termsDialog from './termsDialog';
import error from './error';
import report from './report';
import promotionBanner from './promotionBanner';
import tutorList from './tutorList';
import bank from './bank';
import premiumPage from './premiumPage';
import annualConsent from './annualConsent';

/**
 * @param {Object} [context]
 *
 * Shape of context object:
 *
 *  { history } ---> react router history object
 *
 * History object from react router v4 provide us way to redirect
 * outside of react context. The purpose is to extract redirect logic
 * away from component.
 */
export default function* root(context) {
  yield all([
    call(authSaga),
    call(siteInfoSaga),
    call(signupSaga),
    call(regions),
    call(district),
    call(schools),
    call(curriculum),
    call(navigationSaga, context),
    call(profile),
    call(sendEmail),
    call(resendPhoneVerification),
    call(resetPassword),
    call(resetEmail),
    call(editAccount),
    call(purchaseHistory),
    call(modifySubscription),
    call(cancelSubscription),
    call(redeemReferralCode),
    call(resetUnauthedPassword),
    call(confirmEmail),
    call(plans),
    call(purchaseSaga),
    call(forgotPassword),
    call(updatePhone),
    call(changeSchool),
    call(marketingBanner),
    call(googleTagManager),
    call(deleteAccount),
    call(tutorAudit),
    call(termsDialog),
    call(error),
    call(report),
    call(promotionBanner),
    call(tutorList),
    call(bank),
    call(premiumPage),
    call(annualConsent),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/index.js